import { getQuoteApiForMoney } from "../../common/api/quote";

const merchantCode = 'BES_NZ_UNIQWAY';

const paymentUrlConfig = {
    NZ: new Map([
        [10, `${process.env.MY_CC_URL}/RM-BES_NZ_UNIQWAY/purchase-offset?currency=NZD&cost=10`],
        [15, `${process.env.MY_CC_URL}/RM-BES_NZ_UNIQWAY/purchase-offset?currency=NZD&cost=15`],
        [20, `${process.env.MY_CC_URL}/RM-BES_NZ_UNIQWAY/purchase-offset?currency=NZD&cost=20`],
    ])
}

const getPaymentUrlByCountryAndPrice = (countryCode, price) => {
    return paymentUrlConfig[countryCode].get(price);
}

const doQuoteFromMoney = async (value, currency, merchantCode) => {
    const quoteData = {
      amount:
      {
        value,
        currency
      },
      merchantCode,
      providedAmountFeeMode: "GROSS",
      paymentProvider: "STRIPE",
    }; 

    return await getQuoteApiForMoney(quoteData, 'en_NZ');
}

const oneOffConfig = async () => {
    const amount10 = await doQuoteFromMoney(10, 'NZD', merchantCode);
    const amount15 = await doQuoteFromMoney(15, 'NZD', merchantCode);
    const amount20 = await doQuoteFromMoney(20, 'NZD', merchantCode);

    return {
        NZ: {
            currency:'NZD',
            currencySymbol: '$',
            countryName: 'New Zealand',
            oneOff: [
                {
                    price: '10',
                    amount: Math.round(amount10?.carbonOffsetQuantity.value),
                    src: "https://res.cloudinary.com/carbonclick/image/upload/v1644578820/Enterprise/Uniqway/image-1_y2qdix.jpg",
                    paymentUrl: getPaymentUrlByCountryAndPrice('NZ', 10),
                },
                {
                    price: '15',
                    amount: Math.round(amount15?.carbonOffsetQuantity.value),
                    src: "https://res.cloudinary.com/carbonclick/image/upload/v1644578820/Enterprise/Uniqway/image-3_pwthfc.jpg",
                    paymentUrl: getPaymentUrlByCountryAndPrice('NZ', 15),
                },
                {
                    price: '20',
                    amount: Math.round(amount20?.carbonOffsetQuantity.value),
                    src: "https://res.cloudinary.com/carbonclick/image/upload/v1644578820/Enterprise/Uniqway/image-2_hdg54e.jpg",
                    paymentUrl: getPaymentUrlByCountryAndPrice('NZ', 20),
                },
            ]
        }
    };
}

export {
    merchantCode,
    oneOffConfig
}